import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appTemplateState: {
    template_no: "Template_3",
    templateData: [],
    temp_img_data: {},
  },
};

const reportTemplateSlice = createSlice({
  name: "reportTemplate",
  initialState,
  reducers: {
    updateReportTemplate(state, action) {
      state.appTemplateState = { ...state.appTemplateState, ...action.payload };
    },
  },
});

export const { updateReportTemplate } = reportTemplateSlice.actions;
export default reportTemplateSlice.reducer;
